module.exports = __webpack_public_path__ + "img/A3高速扫描仪.841274aa.jpg";